import React, { forwardRef, useEffect, useLayoutEffect, useState } from "react"
import styled, { css } from "styled-components"

import CurrentSceneSVG from './CurrentSceneSVG'
import { PanelStylingWrapper as PreStyledPanelWrapper } from '../../obsSources/ObsPlayerPanelVertical'
import PlayerPanelShared from '../../components/PlayerPanelShared'
import ScrollingSimpleBoard from '../../obsSources/ScrollingSimpleBoard'
import { defaultSortedPlayers } from "../../utils"
import { ZERO_WIDTH_SPACE } from "../../unicodeChars"
import { accordionLeaveRight, slideRightEnter, slideRightLeave } from "../../customFlipMoveAnimations"
import SortAndPageDashboard from "./SortAndPageDashboard"
import ChapterBoardPreview from "./previews/ChapterBoardPreview"
import SimpleBoardPreview from "./previews/SimpleBoardPreview"
import DetailedBoardPreview from "./previews/DetailedBoardPreview"

import SimpleBoardTable from "../SimpleBoardTable"

import SubmissionsLargeFullGameEntry from "../../obsSources/SubmissionsLargeFullGameEntry"


import FlipMove from "react-flip-move"

import { useStore } from '../../zustandStore'
import { shallow } from 'zustand/shallow'

const FullGameDashboard = ({
  pushPlayerToBroadcast,
  pushLeaderboardToBroadcast,
  pushSubmissionsFeedToBroadcast,
  pushBracketsToBroadcast,
}) => {
  const {
    players,
    event,
    obsState,

    isLoading,
    hasSentUpdate,

    stagedObsState,
    setStagedObsState,
    // setStagedPlayerSlug,
    unstageObsState,

    playerCount,
    publicDisplayedSubmissions,
    disableSubmissionAnimations
  } = useStore(
    state => ({
      players:       state.players,
      event:         state.event,
      obsState:      state.obsState,

      isLoading: state.isLoading,
      hasSentUpdate: state.hasSentUpdate,

      stagedObsState:     state.stagedObsState,
      setStagedObsState:  state.setStagedObsState,
      // setStagedPlayerSlug: state.setStagedPlayerSlug,
      unstageObsState:    state.unstageObsState,

      playerCount: state.players.length,
      publicDisplayedSubmissions: state.publicDisplayedSubmissions,
      disableSubmissionAnimations: !state.publicAppSettings.submissionAnimations
    }),
  )
  
  // const broadcastPlayer     = players.find((p) => p.slug === obsState.currentPlayerSlug)
  // const broadcastPlayerSlug = obsState.currentPlayerSlug

  // const stagedPlayer     = stagedObsState.currentSourceType == 'player' && players.find((p) => p.slug === stagedObsState.currentPlayerSlug)
  // const stagedPlayerSlug = stagedObsState.currentPlayerSlug

  let defaultObsState
  switch (obsState.currentScene) {
    case '1_view':
    case '4_view_simple':
      defaultObsState = {
        currentSourceType: 'leaderboard',
        // currentPage: 1 // maybe in the future comms tools can control pages
      }
      break
      case 'summary':
        defaultObsState = {
          currentSourceType: 'leaderboard',
          currentPage: 1
        }
        break
      case '2_view':
      case '5_view':
      case '4_view_detailed':
      defaultObsState = {
        currentSourceType: 'submissions'
      }
      break
  }

  const broadcastIsDefault = Object.keys(defaultObsState).every((key) => obsState[key] == defaultObsState[key])
  // console.log( { broadcastIsDefault, defaultObsState, obsState } )

  let isLeaderboardOrSubmissionsControlsDisabled
  switch (obsState.currentScene) {
    case '1_view':
    case '4_view_simple':
      isLeaderboardOrSubmissionsControlsDisabled = false
      break
    case 'summary':
    case '2_view':
    case '5_view':
    case '4_view_detailed':
      isLeaderboardOrSubmissionsControlsDisabled = true
      break
  }

  const pushDefaultLayout = (e) => {
    e.preventDefault()
    switch(defaultObsState.currentSourceType) {
      // No single player panel views for full game mode
      // case 'player':
      //   pushPlayerToBroadcast(defaultObsState.currentPlayerSlug)
      //   break
      case 'leaderboard':
        pushLeaderboardToBroadcast({chapterName: defaultObsState.currentChapterName, page: defaultObsState.currentPage})
        break
      case 'submissions':
        pushSubmissionsFeedToBroadcast()
        break
      default:
        throw new Error(`unknown default source type "${defaultObsState.currentSourceType}" for scene name "${obsState.currentScene}"`)
    }
  }

  const stageDefaultObsState = (e) => {
    e.preventDefault()
    switch(defaultObsState.currentSourceType) {
      // case 'player':
      //   setStagedObsState({
      //     ...defaultObsState,
      //     currentChapterName: null,
      //     currentPage: 1
      //   })
      //   break
      case 'leaderboard':
        setStagedObsState({
          ...defaultObsState,
          currentPlayerSlug: null
        })
        break
      case 'submissions':
        setStagedObsState({
          ...defaultObsState,
          currentPlayerSlug: null
        })
        break
    }
  }

  // const onDoubleClickStagedPreview = e => {
  //   e.preventDefault()
  //   switch (stagedObsState.currentSourceType) {
  //     case 'player':
  //       pushPlayerToBroadcast(stagedObsState.currentPlayerSlug)
  //       break
  //     case 'leaderboard':        // {chapterName, page}
  //       pushLeaderboardToBroadcast({ chapterName: stagedObsState.currentChapterName, page: stagedObsState.currentPage })
  //       break
  //   }
  // }

  // const onClickBroadcast = e => {
  //   e.preventDefault()
  //   unstageObsState()
  // }

  // when loadedAtMs changes, that means we received a new update.
  // if hasSentUpdate is true, then this update probably caused by
  // this instance sending an update so we should unstage. if hasSentUpdate
  // is false then it was some other commentator's update so we don't unstage
  // useEffect(() => {
  //   if (hasSentUpdate) {
  //     unstageObsState()
  //   }
  //   console.log({obsState})
  // }, [obsState.loadedAtMs])

  // const NullChapterBoardPreview = () => {
  //   switch(obsState.currentScene) {
  //     case '1_view':
  //     case '4_view_simple':
  //     case '5_view':
  //       return (<SimpleBoardPreview players={players} event={event} />)

  //     case '4_view_detailed':
  //       return (<DetailedBoardPreview players={players} event={event} />)
  //     case 'summary':
  //       return (<DetailedBoardPreview players={players} event={event} />)
  //   }
  // }

  // const LeaderboardPreview = ({obsState}) => {
  //   if (obsState.currentChapterName == null) {
  //     return (<NullChapterBoardPreview />)
  //   } else {
  //     return <ChapterBoardPreview {...obsState} pageSize={obsState.currentScenePageSizes.chapter} className='player-panel '/>
  //   }
  // }

  // const EmptyPreviewPanel = () => (
  //   <PanelPlaceholder>
  //     <div className='display-grid-wrapper'>
  //       <PlayerPanel className='placeholder-outline' event={event} player={players[0]}/>
  //       <div className='placeholder-content'>
  //         Click a player<br/>to preview
  //       </div>
  //     </div>
  //   </PanelPlaceholder>
  // )

  // const PlayerPanel = forwardRef(({ player, onDoubleClick, className }, ref) => (
  //   <div className={className} ref={ref}>
  //     <VerticalPanelStylingWrapper onDoubleClick={onDoubleClick} className='player-panel'>
  //       <PlayerPanelShared player={player} event={event} />
  //     </VerticalPanelStylingWrapper>
  //   </div>
  // ))

  return (<>
    <PreviewWrapper
      anythingStaged={stagedObsState.currentSourceType != null}
    >
      {/* <FlexGrowSpacer>
        <RestoreDefaultButton
          broadcastIsDefault={broadcastIsDefault}
          onClick={broadcastIsDefault ? null : stageDefaultObsState}
          onDoubleClick={pushDefaultLayout}
        >
          <div>Restore</div>
          <div>Defaults</div>
        </RestoreDefaultButton>
      </FlexGrowSpacer> */}

      <PreviewMiddle className='preview-panel'>
        <div className='preview-middle-item'>
          <div>
            Current Scene
          </div>
          <FlipMoveNoOverflow duration={750} enterAnimation={slideRightEnter} leaveAnimation={slideRightLeave}>
            <CurrentSceneSVG key={obsState.currentScene} currentScene={obsState.currentScene} width={175} color='currentColor' />
          </FlipMoveNoOverflow>
        </div>
      </PreviewMiddle>

      {/* literally invisible button with the same style as the visible one to keep flex stuff symmetric */}
      {/* <FlexGrowSpacer>
        <RestoreDefaultButton isPlaceholder>
          <div>Restore</div>
          <div>Defaults</div>
        </RestoreDefaultButton>
      </FlexGrowSpacer> */}
    </PreviewWrapper>
    
    <LeaderboardOrSubmissionsControls className='gradient-background'>
      {(isLeaderboardOrSubmissionsControlsDisabled || isLoading) && (
        <DisabledDiv/>
      )}
      <ToggleLeaderboardOrSubmissionsButton
        disabled={obsState.currentSourceType === 'leaderboard' || isLeaderboardOrSubmissionsControlsDisabled}
        onDoubleClick={pushLeaderboardToBroadcast}
      >
        Show Leaderboard 
      </ToggleLeaderboardOrSubmissionsButton>
      <ToggleLeaderboardOrSubmissionsButton
        disabled={obsState.currentSourceType === 'submissions' || isLeaderboardOrSubmissionsControlsDisabled}
        onDoubleClick={pushSubmissionsFeedToBroadcast}
      >
        Show Submissions
      </ToggleLeaderboardOrSubmissionsButton>
    </LeaderboardOrSubmissionsControls>

    <SimpleBoardAndSubmissionsWrapper>
      <SimpleBoardTable
        wrapperClassName='simple-board-wrapper'
        players={players} // TODO: convert to slugs only
        
        // tableClassName='table-non-pinned'
        // hasOddOffset={hasOddOffset}
        // scaleBy={0.9}
        // scaleByOnPhone={0.75}
        // totalChapterCount={event.chapterNames.length}
        // onClickPlayerRow={onClickPlayerRow}
      />
      <FlipMoveSubmissionsWrapper className='submission-wrapper' key={2} disableAllAnimations={disableSubmissionAnimations} duration={700}>
        {publicDisplayedSubmissions.map((submission) =>
          <SubmissionsLargeFullGameEntry
            key={submission.id}
            submission={submission}
            maxRankDigits={String(playerCount).length}
          />
        )}
      </FlipMoveSubmissionsWrapper>
    </SimpleBoardAndSubmissionsWrapper>
    
    {/* <SortAndPageDashboard
      event={event}
      obsState={obsState}
      players={players}
      pushLeaderboardToBroadcast={pushLeaderboardToBroadcast}
      stagedObsState={stagedObsState}
      setStagedObsState={setStagedObsState}
    /> */}
  </>)
}

export default FullGameDashboard

const LightBlueSpan = styled.span`
  color: lightblue;
`
const FlipMoveNoOverflow = styled(FlipMove)`
  overflow: hidden;
  width: fit-content;
  margin: 0 auto;
`

const SimpleBoardAndSubmissionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 1em;
  justify-content: center;
  min-width: 100vw;

  .simple-board-wrapper {
    max-width: 450px;
    /* width: 30vw; */
  }

  pointer-events: none;
`

const LeaderboardOrSubmissionsControls = styled.div`
  width: 100%;
  max-width: 1150px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;

  border-top: 2px solid #aaa;
  border-bottom: 2px solid #aaa;
  padding: 10px 0;

`



const DisabledDiv = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #2228;
`

const FlipMoveSubmissionsWrapper = styled(FlipMove)`
  /* display: flex;
  flex-direction: column;
  justify-content: space-evenly; */

  /* height: 100vh; */
  max-width: 725px;
  /* width: 45vw; */
  /* margin: 0 auto; */
  font-size: min(0.65em, 2vw);

  .submission-wrapper {
    margin: 0.3em auto;
    border-width: 1px;
  }
  .flag {
    --flag-width: 1.6em;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .rank {
    font-size: 0.8em;
    font-weight: lighter;
    padding-top: 0.1em;
    .monospaced-char {
      flex-direction: column;
      justify-content: flex-end;
      padding: 0;
    }
  }

  .name {
    line-height: normal;
  }
`

// const FlipMove = styled(FlipMove)`
//   display: flex;
//   flex-grow: 6;
//   flex-direction: row;
//   justify-content: space-between;
// `

const PreviewWrapper = styled.div`
  position: relative;
  /* height: 285px; */
  background: linear-gradient(243deg, #33152d, #141732);
  border-top: 2px solid #aaa;
  ${'' /* border-bottom: 2px solid #aaa; */}
  ${'' /* top: -35px; */}
  z-index:3;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;

  margin-left: auto;
  margin-right: auto;

  ${'' /* min-height: 540px; */}
  max-width: var(--detailed-board-width);
  ${'' /* margin-top: -10cqh;
  margin-bottom: -10cqh; */}

  ${'' /* margin: 0 auto 0 auto; */}

  ${'' /* background-color: #33152d; */}
  .staged .player-panel {
    border: 3px dashed ${props => props.anythingStaged ? 'var(--green-text)' : 'var(--greyed-out-button-text)'}!important;
    ${'' /* &:not(.simple-board) { */}
    ${'' /* cursor: pointer; */}
    ${'' /* &:hover { */}
      ${'' /* background-color: #124b74; */}
      ${'' /* border-color: #1d6da6; */}
      ${'' /* background-color: #2b93dc; */}
      ${'' /* background-color: #346940; */}
    ${'' /* } */}
    ${'' /* &:active { */}
      ${'' /* background-color: #144c20; */}
    ${'' /* } */}
    ${'' /* &.no-pointer { */}
      ${'' /* pointer-events: none; */}
    ${'' /* } */}
    ${'' /* } */}
  }
`
const PanelPlaceholder = styled.div`
  ${'' /* > div { display: inline; border: 0; margin: 0; box-shadow: none } */}

  display: flex;
  flex-direction: column;
  align-items: center;

  .placeholder-content {
    z-index: 1;
    visibility: visible;
    ${'' /* max-width: 190px; */}
    font-size: 2em;
    ${'' /* max-height: 400px; */}
    overflow: hidden;
    text-overflow: clip;
    text-align: center;
    margin: auto;
    flex-grow: 1;
    padding: 5px;
    border-radius: 12px;
    ${'' /* border: 3px dashed var(--greyed-out-button-text); */}
  }

  ${'' /* &:hover {
    .placeholder-content {
      visibility: hidden
    }
    .simple-board-wrapper, .player-panel > div {
      opacity: 1;
    }
    .player-panel {
      border: 4px solid #aaa;
    }
  } */}
  ${'' /* width: fit-content;
  height: fit-content; */}
  ${'' /* ${props => props.broadcastIsDefault ? css`
    cursor: not-allowed;
  ` : css`
    cursor: pointer;
  `} */}
`

const PreviewMiddle = styled.div`
  flex-grow: 2;
  font-size: 1.2em;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  ${'' /* max-width: 12%;
  min-width: 12%; */}

  --v-margin: 10px;

  .preview-middle-item {
    width: 210px;

    &:first-child {
      margin-top: var(--v-margin);
      margin-bottom: var(--v-margin);
    }
    &:last-child {
      ${'' /* margin: auto 0 auto 0; */}
      flex-grow: 1;
      display: flex;
      font-size: 1.5em;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      line-height: 1.2em;
    }
  }

  .button {
    padding: 0 10% 0 10%;
  }
  ${'' /* margin-top: auto;
  margin-bottom: auto; */}
`

const RightArrow = styled.div`
  color: #28913f;
  font-size: 2em;
  scale: 3 1;
  width: fit-content;
  margin: 0 auto 0 auto;
`

const StagedPlayerName = styled.div`
  max-width: 175px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const FlexGrowSpacer = styled.div`
  flex-grow: 1.4;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

const RestoreDefaultButton = styled.div`
  user-select: none;
  flex-grow: 1;
  cursor: pointer;
  border: 2px solid #aaa;
  align-self: center;
  ${'' /* margin */}
  ${'' /* font-size: 2em; */}
  min-width: 100px;
  max-width: 140px;
  padding: 0 5px;
  height: 80px;
  border-radius: 3.5px;
  cursor: pointer;
  display: flex;
  font-size: 2em;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #0000;
  padding: 20px;
  margin: 0 30px;



  transition: opacity 0.35s;
  ${props => props.broadcastIsDefault ? css`
    ${'' /* cursor: default; */}
    ${'' /* background-color: var(--greyed-out-button-bg); */}
    ${'' /* color: var(--greyed-out-button-text); */}
    ${'' /* border-color: var(--greyed-out-button-text); */}
    ${'' /* visibility: hidden; */}
    opacity: 0;
    pointer-events: none;
  ` : css`
    ${'' /* background-color: var(--green-selected); */}
    &:hover { background-color: var(--green-hover); }
    &:active { background-color: var(--green-active); }
    opacity: 1;
  `}
  ${props => props.isPlaceholder && css`
    pointer-events: none;
    visibility: hidden;
  `}
`

const VerticalPanelStylingWrapper = styled(PreStyledPanelWrapper)`
  width: 220px;
  padding-bottom: 2px;
  --font-size: 18px;
`

const ToggleLeaderboardOrSubmissionsButton = styled.div`
user-select: none;
  flex-grow: 1;
  cursor: pointer;
  border: 2px solid #aaa;
  align-self: center;
  ${'' /* margin */}
  ${'' /* font-size: 2em; */}
  min-width: 100px;
  max-width: 140px;
  padding: 0 5px;
  height: 80px;
  border-radius: 3.5px;
  cursor: pointer;
  display: flex;
  font-size: 2em;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #0000;
  padding: 20px;
  margin: 0 30px;
  transition: opacity 0.35s;
  text-align: center;
  ${props => props.disabled ? css`
    opacity: 0.3;
    pointer-events: none;
  ` : css`
    opacity: 1;
    &:hover { background-color: var(--green-hover); }
    &:active { background-color: var(--green-active); }
  `}
`
